import type { ComparisonEntry } from './GearTestOrchestrator';

export interface FittingSelection {
  baseline: ComparisonEntry;
  bestSpec: ComparisonEntry;
  bestGear: ComparisonEntry;
  bestBall?: ComparisonEntry;
}

/** Reconcile every displayed total, delta and label from the final selection.
 * Integer tenths match the precision actually shown to the user. */
export function buildFittingSummary(selection: FittingSelection) {
  const { baseline, bestSpec, bestGear, bestBall } = selection;
  const final = bestBall ?? bestGear;
  const tenths = (entry: ComparisonEntry) => {
    const total = Number(entry.formatted.total);
    if (!Number.isFinite(total)) throw new Error('Missing fitting total');
    return Math.round(total * 10);
  };
  const base = tenths(baseline), spec = tenths(bestSpec), gear = tenths(bestGear), end = tenths(final);
  return {
    ...selection, final,
    setupLabel: [bestGear.label, bestBall?.label].filter(Boolean).join(' · '),
    baselineTotal: base / 10, specTotal: spec / 10, gearTotal: gear / 10, finalTotal: end / 10,
    totalGain: (end - base) / 10,
    specGain: (spec - base) / 10, gearGain: (gear - spec) / 10, ballGain: (end - gear) / 10,
  };
}
